import { Link } from '@tanstack/react-router';

interface PageHeaderProps {
  title: string;
  backTo?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function PageHeader({ title, backTo, action }: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        {backTo && (
          <Link
            to={backTo}
            className="p-1.5 rounded-md text-muted hover:text-text hover:bg-surface transition-colors duration-fast"
          >
            <svg
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
              />
            </svg>
          </Link>
        )}
        <h1 className="text-2xl font-bold text-text">{title}</h1>
      </div>
      {action && (
        <button className="btn-primary" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
